import React from 'react';
import { Card } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Scheda07 = () => {

  return (<>
    <PageHeader
    title="Scheda 07"
    description="CRITERI IDENTIFICAZIONE PERIODO E UNITÀ DI MISURA VALORI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Text>
            <p>I PERIODI scelti per la rilevazione delle informazioni sono:</p>
            <ul>
              <li>il <strong>periodo precedente a quello della elaborazione del bilancio di sostenibilità</strong>, considerato come anno di riferimento per la valutazione del grado di RILEVANZA del rischio di impatto e finanziario, in quanto i risultati ottenuti in questo anno rappresentano la situazione di partenza dell’anno precedente a quello di MITIGAZIONE degli stessi rischi.</li> 
              <li>il <strong>periodo oggetto della elaborazione del bilancio di sostenibilità</strong>, relativo all'anno di MITIGAZIONE DEI RISCHI, i cui risultati rappresentano gli effetti di queste mitigazioni che miglioreranno la situazione di partenza per cui corrispondono alla differenza tra quelli dell’anno precedente e quelli dell’anno successivo a questo periodo.</li>
              <li>il <strong>periodo successivo a quello della elaborazione del bilancio di sostenibilità</strong>, come effetto della MITIGAZIONE dei rischi nel periodo precedente, i cui risultati corrispondono alla somma tra quelli del periodo precedente e quelli del bilancio di sostenibilità.</li>
            </ul>
            <p>INPUT:</p>
            <ul>
              <li>Identificazione del periodo in corso (ad esempio: Es. 2024 con anno precedente 2023 e successivo 2025).</li>
            </ul>
            <p>OUTPUT:</p>
            <ul>
              <li>Un prospetto temporale personalizzato ma riferito sempre ad un periodo di tre anni come sopra indicato  .</li>
            </ul>
            <p>LA UNITA’ DI MISURA DEI VALORI scelti come Fattore di scala monetari corrisponde a € migliaia</p>
          </Card.Text>
          <Card.Footer>
              <Link to="/app/metodologia/fase-b">
                <FontAwesomeIcon icon="chevron-left" className="ms-1 fs-11" />&nbsp;&nbsp;&nbsp;
                Torna all'elenco delle schede della fase B EFRAG 
              </Link>
           </Card.Footer>
        </Card.Body>
      </Card>

    </>)
};

export default Scheda07;
